import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const CustomButton = ({
  children,
  loading,
  height = '40px',
  width,
  disabled,
  sx,
  onClick,
  ...props
}) => {
  const theme = useTheme();

  const isLightBg =
    props.variant === 'outlined' ||
    sx?.backgroundColor === '#fff' ||
    sx?.backgroundColor === '#ffffff' ||
    sx?.backgroundColor === 'white' ||
    sx?.backgroundColor === 'transparent';

  const spinnerColor = isLightBg
    ? (sx?.color || theme.palette.primary.main)
    : (sx?.color && sx?.color !== '#fff' && sx?.color !== '#ffffff'
        ? sx.color
        : (theme.palette.secondary.main || '#ffffff'));

  const { startIcon, endIcon, ...restProps } = props;

  const handleClick = (e) => {
    if (loading) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <Button
      disabled={loading ? false : disabled}
      onClick={handleClick}
      startIcon={loading ? undefined : startIcon}
      endIcon={loading ? undefined : endIcon}
      sx={{
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.main,
        textTransform: 'none',
        height: height,
        width: width,
        lineHeight: 3,
        ...sx,
        ...(loading && {
          pointerEvents: 'none',
          opacity: 0.9,
          cursor: 'wait',
        }),
      }}
      {...restProps}
    >
      {loading ? (
        <CircularProgress
          size="1.25rem"
          sx={{
            color: spinnerColor,
            display: 'inline-flex',
            alignSelf: 'center',
          }}
        />
      ) : (
        children
      )}
    </Button>
  );
};

export default CustomButton;
